import {
  type CreateReference,
  getReferenceData,
  type ResourceType,
} from '@quromedical/fhir-common';

type CreatePatientLink = (patientId: string) => string;

const patientLink: CreatePatientLink = (id) => `/patient/${id}/profile`;

const patientLinkMap: Partial<Record<ResourceType, CreatePatientLink>> = {
  Patient: patientLink,
  ClinicalImpression: (id) => `/patient/${id}/notes`,
  Encounter: (id) => `/patient/${id}/notes`,
  Media: (id) => `/patient/${id}/media`,
  Coverage: (id) => `/patient/${id}/clinical`,
  DiagnosticReport: (id) => `/patient/${id}/service-request`,
  ServiceRequest: (id) => `/patient/${id}/service-request`,
  Observation: (id) => `/patient/${id}/vitals`,
  Task: (id) => `/patient/${id}/tasks`,
};

export const getLinkToPatientResource = (
  patient?: CreateReference,
  target?: CreateReference,
): string | undefined => {
  const patientResource = getReferenceData(patient);
  const targetResource = getReferenceData(target);

  if (!patientResource) return undefined;

  const link: CreatePatientLink =
    (targetResource && patientLinkMap[targetResource.resourceType]) ||
    patientLink;

  if (!link) {
    return undefined;
  }

  return link(patientResource.id);
};
